
export const FETCH = 'CHANNELS/FETCH'
export const CLEAR = 'CHANNELS/CLEAR'



// WEBPACK FOOTER //
// ./src/store/modules/channels/mutations.js